<section class="grid-view-instance" >
    <mat-card id="{{cardId}}" class="survey-card ecorr-survey-card uscb-layout-column"
        [class.ecorr-survey-card-expanded]="options || info"
        [ngClass]="{ 'ecorr-survey-card-complete': survey.formStatus === 3, 'ecorr-survey-card-incomplete': survey.formStatus === 2, 'ecorr-survey-card-overdue': survey.formStatus === 1 }"
        mat-whiteframe="6" tabindex="0" [attr.aria-label]="'Survey Card: ' + survey.displayName">

        <h2 class="uscb-title-3 ecorr-card-title uscb-margin-T-10">{{survey.displayName}}</h2>

        @if (hasConfigError()) {
        <span class="config-error-text"><b>There is a configuration error for this survey. 
            Please contact the survey help desk for assistance.</b>
        </span>
        }

        <mat-card-content>
            <section>
                @if (survey.surveyCategory !== 'MEPS') {
                <div class="ecorr-card-status ecorr-text-bold uscb-layout-row uscb-margin-T-20 uscb-margin-B-8">
                    @if (survey.formStatus === 1) {
                    <span class="vcenter ecorr-status-icon">
                        <i class="fa fa-exclamation-circle fa-2x"></i>&nbsp;&nbsp;
                    </span>
                    }
                    <span class="vcenter">Status:&nbsp; </span>
                    <span class="ecorr-status-text vcenter">{{survey.formStatusText}}</span>
                </div>
                }
                @if (survey.disabledMessage && survey.disabledMessage.length > 0 && survey.surveyCategory !== 'MEPS') {
                <div>
                    <span class="ecorr-status-text-row"><span>{{survey.disabledMessage}}</span></span>
                </div>
                }
                @if (survey.formStatus !== 3) {
                <div class="update-text">Please allow 2 business days for status to update.</div>
                }  
            </section>
            <section class="ecorr-card-content">
                @if (survey.surveyCategory !== 'MEPS' && survey.surveyCategory !== 'GUS' && survey.surveyTypeName !== 'ECON - TCIM' && survey.surveyTypeName !== 'ACES') {
                <div class="ecorr-padding-TOP-sm ecorr-card-meta-line"><span class="ecorr-text-bold">Due:</span>
                    {{survey.originalDueDate | date}}</div>
                }
                @if (survey.extended && survey.surveyCategory !== 'MEPS' && survey.surveyCategory !== 'GUS' && survey.surveyTypeName !== 'ECON - TCIM' && survey.surveyTypeName !== 'ACES') {
                <div><span class="ecorr-text-bold">Extended:</span>
                    {{survey.currentDueDate | date}}</div>
                }
                @if (active) {
                <div>
                    <button aria-label="export to calendar" type="button" class="uscb-transparent-button uscb-margin-0 uscb-padding-0"
                        (click)="exportSurvey()" (keyup.enter)="exportSurvey()" [disabled]="hasConfigError()" tabindex="0">
                        <i class="fa fa-calendar"></i> Export to Calendar
                    </button>
                </div>
                }
                <div class="{{survey.formStatus !== 3 ? '' : 'ecorr-padding-TOP-sm'}} ecorr-card-meta-line"><span class="ecorr-text-bold">Name:</span>
                    {{survey.organizationName}}</div>
                @if (survey.brOrganizationId) {
                <div class="ecorr-card-meta-line"><span class="ecorr-text-bold">ID:</span> {{survey.brOrganizationId}}</div>
                }
                @if (survey.accountManager) {
                <div class="uscb-layout-row">
                    <span class="ecorr-text-bold vcenter">Account Manager:</span> &nbsp;
                    <i class="fa fa-info-circle fa-lg ecorr-icon-tooltip uscb-cursor-pointer-hover uscb-margin-8 uscb-font-2x"
                        [matTooltip]="accountManagerTooltipHtml | decodeXml" matTooltipClass="tooltip"></i>
                </div>
                <div>{{survey.accountManager}}, {{survey.accountManagerPhoneNumber}}</div>
                }
            </section>
        </mat-card-content>
        <div class="ecorr-card-divider-row ecorr-flex-none ">
            <mat-divider role="presentation"></mat-divider>
        </div>

        <mat-card-actions class="uscb-layout-row ecorr-flex-none ">
            @if (showOnlyMessage) {
                <button
                (click)="accessMessages()"
                (keyup.enter)="accessMessages()"
                class="uscb-primary-button slim-padding"
                tabindex="0">
                ACCESS MESSAGES
            </button>
            }
            @if (!active && !showOnlyMessage) {
            <button disabled class="uscb-primary-button uscb-color-white uscb-margin-R-10 ecorr-survey-card-closed-action" tabindex="0">
                SURVEY CLOSED
            </button>
            }

            @if (active && !showOnlyMessage && !survey.caseId) {
            <form id="startForm" ngNoForm [action]="survey.centurionUrl" method="POST" target="_blank"
                class="uscb-form uscb-margin-R-10">
                <input id="authCode" name="authCode" value="{{survey.smartId}}" type="hidden">
                <!-- Centurion SSO -->
                <input id="origin" name="origin" value="portal" type="hidden">

                <!-- <button type="submit" #submitButton *ngIf="survey.reportingEnabled !=='N'" fxFlex="none" class="uscb-primary-button"
                    (click)="accessCenturion(survey.surveyInstanceId, user.userAccountId)" (keyup.enter)="accessCenturion(survey.surveyInstanceId, user.userAccountId)" 
                    [disabled]="configError" tabindex="0">
                    REPORT NOW
                </button> -->
                
                @if (survey.reportingEnabled !=='N' && !survey.caseId) {
                <button type="submit" #submitButton class="uscb-primary-button ecorr-flex-none"
                    (click)="accessCenturion(survey, currentUser()?.userAccountId)" (keyup.enter)="accessCenturion(survey, currentUser()?.userAccountId)" 
                    [disabled]="hasConfigError()" tabindex="0">
                    REPORT NOW
                </button>
                }

                @if (survey.reportingEnabled ==='N') {
                <button disabled class="uscb-primary-button ecorr-flex-none"
                    [matTooltip]="survey.disabledMessage" matTooltipClass="tooltip" tabindex="0">
                    REPORT NOW
                </button>
                }
            </form>
            }

            @if (active && !showOnlyMessage && (survey.caseId && survey.caseId > 0)) {
            <ng-container>
                @if (survey.reportingEnabled !=='N') {
                <a (click)="openSurveyReportNow(survey, currentUser())" target="_blank" class="uscb-primary-button">
                    REPORT NOW
                </a>
                }

                @if (survey.reportingEnabled ==='N') {
                <button disabled class="uscb-primary-button ecorr-flex-none"
                    [matTooltip]="survey.disabledMessage" matTooltipClass="tooltip" tabindex="0">
                    REPORT NOW
                </button>
                }
            </ng-container>
            }

            @if (active) {
            <button aria-label="options" type="button"
                class="uscb-transparent-button ecorr-survey-card-options-action uscb-margin-0 uscb-padding-TB-0 uscb-padding-LR-5 ecorr-flex-none"
                (click)="optionsClick()" (keyup.enter)="optionsClick()" [ngClass]="options ? 'button-pressed' : 'button-released'"
                [disabled]="hasConfigError()" tabindex="0" [attr.aria-expanded]="options">
                @if (!options) {
                <i class="fa fa-plus-circle"></i>
                }
                @if (options) {
                <i class="fa fa-minus-circle"></i>
                }
                &nbsp;OPTIONS
            </button>
            }

            @if ((survey.surveyInformation || survey.infoUrl)) {
            <button
                aria-label="information"
                class="uscb-transparent-button ecorr-survey-card-info-action ecorr-flex-none"
                (click)="infoClick()"
                (keyup.enter)="infoClick()"
                [ngClass]="info ? 'button-pressed' : 'button-released'"
                [disabled]="hasConfigError()"
                tabindex="0"
                [attr.aria-expanded]="info">
                <i class="fa fa-info"></i>
            </button>
            }
        </mat-card-actions>

        @if (options) {
        <mat-card-content
            class="ecorr-survey-card-extension uscb-layout-column uscb-layout-align-space-between uscb-layout-align-vert-stretch uscb-margin-LR--10 ecorr-flex-none">
            @if (!showOnlyMessage) {
            <ng-container>
                <button (click)="requestExtension()" (keyup.enter)="requestExtension()" [disabled]="survey.timeExtensionIndicator !== 'Y' || !currentSettings().pegaIntegration" tabindex="0">
                    <i class="fa fa-clock-o"></i>Request Extension
                </button>
                <mat-divider role="presentation"></mat-divider>

                <button (click)="shareAccess()" (keyup.enter)="shareAccess()" tabindex="0">
                    <i class="fa fa-users"></i>Share Survey Access
                </button>
                <button (click)="checkStatus()" (keyup.enter)="checkStatus()" tabindex="0">
                    <i class="fa fa-check-square-o"></i>Filing Status
                </button>
                <mat-divider role="presentation"></mat-divider>

                <button (click)="viewFAQs(-1)" (keyup.enter)="viewFAQs(-1)" tabindex="0">
                    <i class="fa fa-question-circle"></i>Survey FAQs
                </button>

                @if (showFaqChildren) {
                <mat-divider role="presentation"></mat-divider>
                <div class="uscb-layout-row uscb-layout-align-space-between uscb-layout-align-vert-center">
                    <button title="Rpt. of Org. FAQs" class="ecorr-faq-child uscb-flex-col-50 uscb-margin-0" (click)="viewFAQs(0)" (keyup.enter)="viewFAQs(0)" tabindex="0">Rpt. of Org.
                        FAQs</button>
                    <button title="ASM FAQs" class="ecorr-faq-child uscb-flex-col-30" (click)="viewFAQs(1)" (keyup.enter)="viewFAQs(1)" tabindex="0">ASM
                        FAQs</button>
                </div>
                <mat-divider role="presentation"></mat-divider>
                }
            </ng-container>
            }

            <button [disabled]="!currentSettings().pegaIntegration" (click)="sendMessage()" (keyup.enter)="sendMessage()" tabindex="0">
                <i class="fa fa-envelope"></i>Send Message
            </button>
            @if (survey.phoneNbr) {
            <button class="ecorr-cursor-default" tabindex="0">
                <i class="fa fa-phone"></i>Call Survey Support: {{survey.phoneNbr}}
            </button>
            }
        </mat-card-content>
        }

        @if (info) {
        <mat-card-content
            class="ecorr-survey-card-extension uscb-layout-column uscb-layout-align-space-between uscb-layout-align-vert-stretch uscb-margin-LR--10 ecorr-flex-none">
            <p class="ecorr-survey-card-info" [innerHtml]="survey.surveyInformation | decodeXml | byPassSecurity"></p>
            @if (survey.infoUrl) {
            <div class="uscb-layout-column">
                @if (!survey.infoUrl.includes(';')) {
                <button mat-flat-button color="accent"
                    class="mat-button ecorr-survey-card-info-button" (click)="moreInfoClick(-1)" (keyup.enter)="moreInfoClick(-1)" tabindex="0">MORE INFORMATION</button>
                }
                @if (survey.infoUrl.includes(';')) {
                <button mat-flat-button color="accent" class="mat-button ecorr-survey-card-info-button"
                    (click)="moreInfoClick(0)" (keyup.enter)="moreInfoClick(0)" tabindex="0">Rpt. of Org. INFORMATION</button>
                <button mat-flat-button color="accent" class="mat-button ecorr-survey-card-info-button"
                    (click)="moreInfoClick(1)" (keyup.enter)="moreInfoClick(1)" tabindex="0">ASM INFORMATION</button>
                }
            </div>
            }
        </mat-card-content>
        }

    </mat-card>
</section>